import { useState } from 'react';

import { usePreviousValue } from '~/components/MobileHeaderCard/hooks';

/**
 * Hook to manage limit reached tooltip state
 * @param isLimitReached - Whether the limit has been reached
 * @returns Object with tooltip state and close handler
 */
export const useLimitReachedTooltip = (
  isLimitReached: boolean,
  openOnMount = false,
) => {
  const [isOpen, setIsOpen] = useState(openOnMount && isLimitReached);

  const handleClose = () => {
    setIsOpen(false);
  };

  usePreviousValue(isLimitReached, (newVal) => {
    setIsOpen(newVal);
  });

  return {
    isOpen,
    onClose: handleClose,
  };
};
